import React, { useEffect, useState } from 'react'
import EmptyState from '../../../pages/empty-state'
import chainImage from "../../../assets/media/dashboard/chain.svg"
import funnelImage from "../../../assets/media/dashboard/funnel.svg"
import targetImage from "../../../assets/media/dashboard/target.svg"
import { useSelector } from 'react-redux'
import { hideLoader, showLoader } from '../../loader'
import { apiUrl } from '../../../utils/url'
import CommunityFooter from '../../community/footer'
import HeaderSearch from '../../community/headerSearch'
import tickIcon from "../../../assets/img/tick.svg"
import buttonClick from "../../../assets/img/buttonClick.png"

let params = []
const Analytics = (props) => {
  const { productData, iframeURL, iframeIndex, productSlug } = props;
  const [loading, setloading] = useState(true);
  const { slug, basePath } = useSelector(state => state?.slugReducer);
  const [dateRange, setDateRange] = useState('last_7_days');
  const [globalAnalytics, setGlobalAnalytics] = useState({
    totalPageViews: 0,
    totalClicks: 0,
    clickRate: 0
  });

  const [filter, setfilter] = useState({
    page: 1,
    orderBy: null,
    filter: null,
    orderType: "asc",
    count: localStorage?.leads_count ?? 10
  })
  const [activities, setActivities] = useState([]);
  useEffect(() => {
    if (slug && productData.id) {
      params = [];
      Object.keys(filter).forEach(key => {
        if (filter[key]) {
          params.push(`${key}=${filter[key]}`);
        }
      });
      if (filter?.page) getAnalytics(slug, productData.id);
    }
  }, [slug, productSlug, filter]);
  const getAnalytics = async (slug, campaign_id) => {
    setloading(true);
    showLoader();
    const api = `${apiUrl}/campaigns/analytics/get/${slug}/${campaign_id}?${params.join("&")}`;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
    const setOptions = {
      method: "GET",
      headers: myHeaders,
    };
    fetch(api, setOptions)
      .then(async (res) => {
        const response = await res?.json();
        if (response?.status_code == 200) {
          setloading(false);
          setActivities(response?.data);
        }
        hideLoader();
      }).catch(() => {
        hideLoader();
      });
  };
  const addFilter = (val) => {
    setfilter(prevFilter => ({ ...prevFilter, filter: val !== 'all' ? val : null }));
  };
  useEffect(() => {
    if (slug && productData.id) {
      handleDateChange();
    }
  }, [dateRange, slug, productSlug]);
  const handleDateChange = async () => {
    const api = `${apiUrl}/campaigns/analytics/get-all/${slug}/${productData?.id}?dateRange=${dateRange}`;

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
    const setOptions = {
      method: "GET",
      headers: myHeaders,
    };
    fetch(api, setOptions)
      .then(async (res) => {
        const response = await res?.json();
        if (response.status_code === 200) {
          setGlobalAnalytics(response?.data);
        } else {
          console.error(response?.status_message);
        }
      }).catch(() => {
        hideLoader();
      });
  };
  return (
    <>
      {/* {!allAudience?.data?.length > 0 ?
        <div className='position-relative h-100 w-100 '>
          <EmptyState from={"campaign-analyics"} secondText={'Coming Soon'} />
        </div>
        : */}
      <div className='analytics-container project-scrollbar'>
        <div className='d-flex flex-column gap-3'>
          <div className='generate-page-heading text-start mb-0'>Analytics</div>
          <div className="date-btns-selector">
            <div onClick={() => setDateRange('last_7_days')} className={`${dateRange == "last_7_days" ? 'active' : ''} date-filter-button me-2`} name="last_7_days">Last 7 Days</div>
            <div onClick={() => setDateRange('last_14_days')} className={`${dateRange == "last_14_days" ? 'active' : ''} date-filter-button me-2`} name="last_14_days">Last 14 Days</div>
            <div onClick={() => setDateRange('last_30_days')} className={`${dateRange == "last_30_days" ? 'active' : ''} date-filter-button`} name="last_30_days">Last 30 Days</div>
          </div>
          <div className='leads-analytics-cards-container'>
            <div className="views-card card dashboard-analytics-cards" data-color="views-card-hover" id="dashboard-analytics-cards">
              <div className="" style={{ padding: "15px" }}>
                <div className="card-heading dashboard-card-heading">
                  Views
                </div>
                <div className="card-text dashboard-card-text text-capitalize">
                  {dateRange?.replace(/_/g, ' ')}
                </div>
                <div className="dashboard-card-numbers">
                  {globalAnalytics?.totalPageViews}
                </div>
              </div>
              <div className="leads-analytics-card-pic-div">
                <img className="views-card-image" src={chainImage} alt="" />
              </div>
            </div>
            <div className="clicks-card card dashboard-analytics-cards" data-color="clicks-card-hover" >
              <div className="" style={{ padding: "15px" }}>
                <div className="card-heading dashboard-card-heading">
                  Clicks Rate
                </div>
                <div className="card-text dashboard-card-text text-capitalize">
                  {dateRange?.replace(/_/g, ' ')}
                </div>
                <div className="dashboard-card-numbers">
                  {globalAnalytics?.clickRate}
                </div>
              </div>
              <div className="canalytics-card-pic-div">
                <img className="clicks-card-image" src={funnelImage} alt="" />
              </div>
            </div>
            <div className="sales-card card dashboard-analytics-cards" data-color="sales-card-hover" >
              <div className="" style={{ padding: "15px" }}>
                <div className="card-heading dashboard-card-heading">
                  Button Clicks
                </div>
                <div className="card-text dashboard-card-text text-capitalize">
                  {dateRange?.replace(/_/g, ' ')}
                </div>
                <div className="dashboard-card-numbers">
                  {globalAnalytics?.totalClicks}
                </div>
              </div>
              <div className="leads-analytics-card-pic-div">
                <img className="sales-card-image" src={targetImage} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="leads-analytics-container">
          {/* Header */}
          <div className="leads-analytics-header">
            <div className="leads-analytics-links">
              <span className="leads-analytics-active-link">Activity</span>
            </div>

            <div className="leads-analytics-actions">
              <div className="leads-analytics-search">
                <HeaderSearch filter={filter} setfilter={setfilter} name="by email" />
                {/* <Search className="leads-analytics-search-icon" /> */}
              </div>
              <div class="text- filter-action-dropdown  dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers" id="filter-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                    <rect y="0.5" width="15" height="15" rx="3" fill="#1188FF" />
                    <path d="M3 6.5L9 6.5M9 6.5C9 7.32843 9.67157 8 10.5 8C11.3284 8 12 7.32843 12 6.5C12 5.67157 11.3284 5 10.5 5C9.67157 5 9 5.67157 9 6.5ZM6 10.5L12 10.5M6 10.5C6 11.3284 5.32843 12 4.5 12C3.67157 12 3 11.3284 3 10.5C3 9.67157 3.67157 9 4.5 9C5.32843 9 6 9.67157 6 10.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <span className='text-capitalize'>
                  {filter?.filter ?? 'All'}
                </span>
              </div>
              <ul className="filter-dropdown-menu dropdown-menu" aria-labelledby="filter-action-dropdown">
                <li
                  onClick={() => addFilter('all')}
                  className={`filter-dropdown-item ${!filter?.filter ? 'active' : ''}`}>
                  <span>All</span>
                  {!filter?.filter && <img src={tickIcon} width={9} alt="" />}
                </li>
                <li
                  onClick={() => addFilter('desktop')}
                  className={`filter-dropdown-item ${filter?.filter === 'desktop' ? 'active' : ''}`}>
                  <span>Desktop</span>
                  {filter?.filter === 'desktop' && <img src={tickIcon} width={9} alt="" />}
                </li>
                <li
                  onClick={() => addFilter('tablet')}
                  className={`filter-dropdown-item ${filter?.filter === 'tablet' ? 'active' : ''}`}>
                  <span>Tablet</span>
                  {filter?.filter === 'tablet' && <img src={tickIcon} width={9} alt="" />}
                </li>
                <li
                  onClick={() => addFilter('mobile')}
                  className={`filter-dropdown-item ${filter?.filter === 'mobile' ? 'active' : ''}`}>
                  <span>Mobile</span>
                  {filter?.filter === 'mobile' && <img src={tickIcon} width={9} alt="" />}
                </li>
              </ul>

            </div>
          </div>

          <div className="leads-analytics-activity-list project-scrollbar">
            {/* Activity List */}
            <div className="leads-analytics-activity-item mb-4">
              <div className="leads-analytics-activity-details">
                <span className="leads-analytics-email leads-analytics-heading">Email</span>
                <div className="leads-analytics-time-step">
                  <span className='leads-analytics-heading custom-td-width'>
                    <span className='me-1'>
                      <img src={require(`../../../assets/img/flags/Unknown.png`)} width={14} height={14} alt="" />
                    </span>
                    <span>
                      Country
                    </span>
                  </span>
                  <span className='leads-analytics-heading custom-td-width'>
                    <span className='me-1'>
                      <img src={buttonClick} width={14} height={14} alt="" />
                    </span>
                    Button Clicks
                  </span>
                  <span className="leads-analytics-gap leads-analytics-heading">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Last Modified
                  </span>
                </div>
              </div>
            </div>
            {activities?.data?.length > 0 && activities?.data?.map((activity, index) => (
              <div key={index} className="leads-analytics-activity-item leads-analytics-body">
                <div className="leads-analytics-icon-container" style={{backgroundColor:productData?.branding?.brand_color}}>
                  {activity?.subscriber?.logo && <img src={activity?.subscriber?.logo}/>}
                </div>
                <div className="leads-analytics-activity-details">
                  <span className="leads-analytics-email">{activity?.subscriber?.email}</span>
                  <div className="leads-analytics-time-step">
                    <span className="leads-analytics-gap custom-td-width">
                    <span>
                      {(() => {
                        try {
                          return (
                            <img
                              src={require(`../../../assets/img/flags/${activity?.country_code?.toLowerCase() || 'Unknown'}.png`)}
                              alt=""
                              width="22px"
                            />
                          );
                        } catch (error) {
                          return <img src={require(`../../../assets/img/flags/Unknown.png`)} alt="" width="22px"/>;
                        }
                      })()}
                    </span>
                      <span className='leads-analytics-country'>
                        {activity?.country_code ?? 'Unknown'}
                      </span>
                    </span>
                    <span className='custom-td-width button_click'>
                      {activity?.button_clicks}
                    </span>
                    <span className="leads-analytics-gap">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      {activity?.updated_at_humans}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div class="section-footer d-flex align-items-center justify-content-between">
          <CommunityFooter loading={loading} from={"leads"} filter={filter} setfilter={setfilter} total={activities?.total} last_page={activities?.last_page} current_page={activities?.current_page} />
        </div>
      </div>
      {/* } */}
    </>

  )
}

export default Analytics